@if (isPopupVisible) {
  <dx-popup
    contentTemplate="popup-content"
    [(visible)]="isPopupVisible"
    title="Create Workload"
    position="center"
    [hideOnOutsideClick]="true"
    [showTitle]="true"
    [height]="650"
    [width]="700"
    [resizeEnabled]="false"
    [dragEnabled]="false"
    (onHidden)="onCloseModal()"
    (onShowing)="prepareData()"
  >
    <div *dxTemplate="let data of 'popup-content'">
      <form [formGroup]="localForm">
        <section class="petc mb-1" formGroupName="petc">
          <dx-autocomplete
            [dataSource]="resources"
            label="PE/TC"
            labelMode="outside"
            valueExpr="name"
            (onSelectionChanged)="onPetcSelection($event)"
            [value]="pep.name"
          ></dx-autocomplete>
          <dx-number-box
            label="PE/TC Hours"
            labelMode="outside"
            formControlName="hours"
            [showSpinButtons]="false"
            [showClearButton]="false"
          >
          </dx-number-box>
        </section>
        <section class="figure mb-1" formGroupName="figure">
          <dx-select-box
            [dataSource]="practices"
            formControlName="practiceId"
            label="Practice"
            labelMode="outside"
            valueExpr="id"
            displayExpr="description"
            [searchEnabled]="true"
            (onSelectionChanged)="onPracticeSelection($event)"
          >
          </dx-select-box>
          <dx-select-box
            [dataSource]="filteredDisciplines"
            formControlName="disciplineId"
            label="Discipline"
            labelMode="outside"
            valueExpr="id"
            displayExpr="description"
            [searchEnabled]="true"
            (onSelectionChanged)="onSelectionChanged()"
          >
          </dx-select-box>
          <dx-select-box
            [dataSource]="figures"
            formControlName="professionalFigureId"
            label="Professional Figure"
            labelMode="outside"
            valueExpr="id"
            displayExpr="description"
            [searchEnabled]="true"
            (onSelectionChanged)="onSelectionChanged()"
          >
          </dx-select-box>
          <dx-select-box
            [dataSource]="geos"
            formControlName="geoId"
            label="Country"
            labelMode="outside"
            valueExpr="id"
            displayExpr="description"
            [searchEnabled]="true"
            (onSelectionChanged)="onSelectionChanged()"
          >
          </dx-select-box>
          <dx-number-box
            label="Hours to plan"
            labelMode="outside"
            formControlName="hours"
            [showSpinButtons]="false"
            [showClearButton]="false"
          >
          </dx-number-box>
        </section>
        <section class="opp" formGroupName="opp">
          <dx-date-box
            type="date"
            label="Start date"
            labelMode="outside"
            formControlName="dateStart"
            [value]="startDate"
            [displayFormat]="'x' | calendarDate"
            [min]="minDate"
            [max]="maxDate"
          >
          </dx-date-box>
          <dx-date-box
            type="date"
            label="End date"
            labelMode="outside"
            formControlName="dateEnd"
            [value]="endDate"
            [displayFormat]="'x' | calendarDate"
            [min]="minDate"
            [max]="maxDate"
          >
          </dx-date-box>

          <div class="spread">
            <div class="label">Copilot strategy:</div>
            <div class="field">
              <dx-radio-group
                [id]="'copilotStrategy'"
                [items]="spreads"
                [value]="spreads[0].id"
                valueExpr="id"
                displayExpr="desc"
                layout="horizontal"
                formControlName="distributionType"
              >
              </dx-radio-group>
            </div>
          </div>
        </section>
      </form>
      <dx-tooltip
        [target]="'#copilotStrategy'"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
      >
        <p style="text-align: left">
          <strong>Linear</strong>:&nbsp;Hours are divided by the number of weeks
          and spread on them<br />
          <strong>FTE Hours</strong>:&nbsp;Hours are filled on all selected
          weeks<br />
          <strong>Max on start</strong>:&nbsp;Hours are planned, based on
          availability, on first week selected. Remaining hours are planned on
          subsequent weeks until hours are totally planned<br />
          <strong>Ramp up</strong>:&nbsp;Hours are planned, based on
          availability, on last week selected. Remaining hours are planned on
          previous weeks until hours are totally planned
        </p>
      </dx-tooltip>
    </div>
    <dxi-toolbar-item
      widget="dxButton"
      toolbar="bottom"
      location="after"
      [options]="closeButtonOptions"
    >
    </dxi-toolbar-item>
    <dxi-toolbar-item
      widget="dxButton"
      toolbar="bottom"
      location="after"
      [options]="saveButtonOptions"
      [disabled]="!localForm.valid"
    >
    </dxi-toolbar-item>
  </dx-popup>
}
